// --- START OF FILE ColorPicker.js ---

// components/user/ColorPicker.js
import React, { useState } from 'react';
import {
    Button,
    Popover,
    Box,
    TextField,
    makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    colorButton: {
        width: '100%',
        height: '40px',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: theme.shape.borderRadius,
        padding: 0,
        '&:hover': {
            border: '1px solid rgba(0, 0, 0, 0.87)',
        }
    },
    colorGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: theme.spacing(1),
        padding: theme.spacing(2),
    }
}));

const presetColors = [
    '#ffffff', '#f5f5f5', '#e0e0e0', '#9e9e9e', '#212121',
    '#ef5350', '#ec407a', '#ab47bc', '#7e57c2', '#5c6bc0',
    '#42a5f5', '#29b6f6', '#26c6da', '#26a69a', '#66bb6a',
    '#9ccc65', '#d4e157', '#ffee58', '#ffca28', '#ffa726'
];

export const ColorPicker = ({ color, onChange }) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [inputColor, setInputColor] = useState(color);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleColorChange = (newColor) => {
        onChange(newColor);
        setInputColor(newColor);
        handleClose();
    };

    const handleInputChange = (e) => {
        const newColor = e.target.value;
        setInputColor(newColor);
        if (newColor.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
            onChange(newColor);
        }
    };

    const open = Boolean(anchorEl);
    const id = open ? 'color-popover' : undefined;

    return (
        <>
            <Button
                className={classes.colorButton}
                onClick={handleClick}
                style={{ backgroundColor: color }}
            />

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ width: 300 }}>
                    <Box className={classes.colorGrid}>
                        {presetColors.map((presetColor) => (
                            <Button
                                key={presetColor}
                                style={{
                                    backgroundColor: presetColor,
                                    width: '40px',
                                    height: '40px',
                                    minWidth: 'unset',
                                    border: color === presetColor ? '2px solid #000' : '1px solid rgba(0,0,0,0.12)'
                                }}
                                onClick={() => handleColorChange(presetColor)}
                            />
                        ))}
                    </Box>
                    <Box sx={{ p: 2 }}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Hex Color"
                            value={inputColor}
                            onChange={handleInputChange}
                            placeholder="#000000"
                        />
                    </Box>
                </Box>
            </Popover>
        </>
    );
};